<template lang="pug">
	div
		div(v-for="(cat, key) in myParticipant.data.event.extra_data_category || []" v-if="myParticipant.data.reg_extra_data.filter(item=> item.extra_data_type.category === cat.id).length !==0" :key="key")
			h4.mt-4.mb-3 {{ cat.title }}
			b-row
				b-col(sm="6" md="4" lg="4" xl="3" v-for="(data,key) in myParticipant.data.reg_extra_data.filter(item=> item.extra_data_type.category === cat.id)" :key="key")
					b-card.overflow-hidden(no-body)
						b-row.align-items-center(no-gutters)
							b-col.d-flex.align-items-center(cols='3')
								b-card-img.rounded-0(:src="data.extra_data_type.image || 'https://picsum.photos/200/200/?image=20'" width="50")
							b-col(cols='9')
								b-card-body
									h5(slot="header") {{ data.extra_data_type.title }}
									b-card-text {{ data.extra_data_type.description }}
		h4.mt-4.mb-3(v-if="myParticipant.data.event.use_price") Стоимость: {{ myParticipant.data.price }} ₽

</template>

<script>
	import { mapState } from 'vuex';

	import lectureModalEdit from '../../components/modals/lectureModalEdit'

	export default {
		name: 'extraDatas',
		props:['_ppnt'],
		components: {
			lectureModalEdit,
		},
		data: () => ({
			form: {},
		}),
		computed: {
			...mapState(['myParticipant', 'account']),
		},
	}
</script>

<style>

</style>
